
function SdFileIconCtrl(TranslationService, DocService) {
    var ctrl = this;
    ctrl.translation = TranslationService.getActiveTranslation();

    ctrl.fileTypes = [];
    ctrl.fileTypes.push('PDF');
    ctrl.fileTypes.push('XLS');
    ctrl.fileTypes.push('XLSX');

    ctrl.getFileExtension = function (fileName) {
        return DocService.getFileExtension(fileName);
    };

    ctrl.isOther = function (fileName) {
        var ext = DocService.getFileExtension(fileName);
        if (ctrl.fileTypes.includes(ext))
        {
            return false;
        }
        return true;
    };
}

SdFileIconCtrl.$inject = ['TranslationService', 'DocService'];

seedWebApp.component('sdFileIcon', {
    controller: SdFileIconCtrl,
    controllerAs: 'ctrl',
    bindings: {
        name: '<',
    },
    templateUrl: '/SPA/Orders/sd-file-icon.html' + seedWebApp.buildVersion
});
